import { useQuery } from "@tanstack/react-query";
import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

export interface IndicationVerdictMentionView {
  text: string;
  /** Where it was written, for example "referral letter · p1". */
  source: string;
  /** The document tab it sits on; `null` for a raw file the QA app does not show. */
  fileIdentifier: string | null;
  /** The S3 key of the document the mention was read from, to pick between two documents of one type. */
  objectKey: string | null;
}

export interface IndicationVerdictView {
  position: number;
  /** The indication's name; null on rows written before it was stored. */
  label: string | null;
  verdict: "coded" | "not-coded";
  ruleId: string;
  ruleDefinition: string | null;
  /** The checks could not run: a failed check, not a rule's decision. */
  isNotClassified: boolean;
  reason: string;
  personalHistory: boolean;
  absent: boolean;
  mentions: IndicationVerdictMentionView[];
}

async function fetchIndicationVerdicts(encounterId: string): Promise<IndicationVerdictView[]> {
  const response = await fetchWithSupabaseAuth(`${QA_API_DOMAIN}/indication-verdicts/${encounterId}`);
  if (!response.ok) throw new Error("Failed to fetch indication verdicts");
  const data = await response.json();
  return data.verdicts;
}

export function useIndicationVerdicts(encounterId: string | undefined) {
  return useQuery({
    queryKey: ["indication-verdicts", encounterId],
    queryFn: () => fetchIndicationVerdicts(encounterId!),
    enabled: !!encounterId,
  });
}
